import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getChannelChatMessages, getChatMessage } from '../../services/chatService'
import useNotifications from '../../hooks/useNotifications'

export default function useChat(channelId) {
  const { t } = useTranslation()
  const { error } = useNotifications()
  const [chat, setChat] = useState()
  const [parentMessage, setParentMessage] = useState()
  const fetchChat = useCallback(async () => {
    if (channelId) {
      try {
        const response = await getChannelChatMessages(channelId, 1, null, null)
        setChat(response.data)
        if (response.data.type === 'fs_thread' && response.data.messages && response.data.messages.length > 0) {
          const parentMessageResponse = await getChatMessage(response.data.messages[0].parentMessageId)
          setParentMessage(parentMessageResponse.data)
        }
      } catch (err) {
        error(
          `${t('chat.errorFetchingChatData', {
            defaultValue: 'Something went wrong fetching chat data',
          })}${err.message ? `: ${err.message}` : ''}`,
          err
        )
      }
    }
  }, [channelId, error, t])

  useEffect(() => {
    fetchChat()
  }, [fetchChat])

  return { chat, fetchChat, parentMessage }
}
